import React from 'react'
import UserPage from '../../common/UserPage/UserPage';
import Footer from '../../common/Footer/Footer';
import TherapistEditPage from '../../components/TherapistEdit/TherapistEdit';

function TherapistEditpage() {
  return (
    <div>
        <UserPage  />
        <TherapistEditPage />
        <Footer />
    </div>
  )
}

export default TherapistEditpage